import useSWR from 'swr'
import fetcher from '../utils/fetcher'

const useSearch = (country, search) => {
    const url = `https://extranet.greentec.eu/api/coordinates?country=${country}&search=${search}`
    const shouldFetch = country && search
    const {data, error, isLoading, isValidating} = useSWR(shouldFetch ? url : null, fetcher, {
        keepPreviousData: true
    })

    return {
        location: data,
        locationLoading: isLoading,
        locationValidating: isValidating,
        locationError: error
    }
}

export default useSearch